import AnatomyV2Intro from '~/pages/anatomyV2/intro/libs/components/AnatomyV2Intro'
import { TPageProps } from '~/shared/types/commonTypes'

const IntroAnatomyV2 = ({ nextPagePath }: TPageProps) => (
  <AnatomyV2Intro nextPagePath={nextPagePath} />
)

export default IntroAnatomyV2
